<script lang="ts">
	import { page } from '$app/state';
	import type { Snippet } from 'svelte';

	interface Props {
		href: string;
		children: Snippet;
	}

	let { href, children }: Props = $props();

	let active = $derived(page.url.pathname === href);

	let scaleOrigin = $state('origin-left');

	$effect(() => {
		if (active) {
			scaleOrigin = 'origin-left';
		} else {
			scaleOrigin = 'origin-right';
		}
	});
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
	class={['group flex flex-col', { 'text-brown-2': active, 'text-stone-1': !active }]}
	onmouseenter={() => (scaleOrigin = 'origin-left')}
	onmouseleave={() => (scaleOrigin = 'origin-right')}
>
	<a
		{href}
		class="mb-[6px] py-[10.5px] text-[16px] font-semibold leading-[19.2px] lg:mb-[2px] lg:py-[14.5px]"
	>
		{@render children()}
	</a>
	<div
		class={[
			'h-[2px] w-full transform-gpu bg-brown-2 transition-transform duration-400 ease-in-out group-hover:scale-100',
			scaleOrigin,
			{
				'scale-0': !active,
				'scale-100': active
			}
		]}
		ontransitionend={() => (scaleOrigin = 'origin-left')}
	></div>
</div>
